$(function () {
	const cardSlider = new Swiper('.js-card-slider', {
		pagination: {
			el: '.card-pagination',
		},
		on: {
			init: function () {
				let speed = $(window).width() > 1279 ? 0 : 1200;
				this.params.speed = speed;
			},
		},
	});

	if (cardSlider && $(window).width() > 1279) {
		let tempCardSlider = cardSlider.length ? cardSlider : [cardSlider];

		tempCardSlider.forEach(element => {
			let pagination = element.pagination.bullets

			$(pagination).hover(function () {
				let index = $(this).index();

				element.slideTo(index);
			});
		});
	}

	$('.card').mouseleave(function () {
		$(this).find('.card__slider')[0].swiper.slideTo(0);
	});

	const newsSlider = new Swiper('.js-news-slider', {
		slidesPerView: 1,
		spaceBetween: 8,
		speed: 1200,
		breakpoints: {
			768: {
				slidesPerView: 2.1,
				spaceBetween: 16,
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			1600: {
				slidesPerView: 4,
				spaceBetween: 16,
			}
		},
		navigation: {
			nextEl: '.news-button-next',
			prevEl: '.news-button-prev'
		}
	});

	const projectThumbs = new Swiper('.js-project-thumbs', {
		slidesPerView: 'auto',
		// spaceBetween: 8,
		watchSlidesProgress: true,
	});

	const projectSlider = new Swiper('.js-project-slider', {
		// slidesPerView: 1,
		spaceBetween: 0,
		speed: 1200,
		thumbs: {
			swiper: projectThumbs,
		},
	});

	const similarSlider = new Swiper('.js-similar-slider', {
		slidesPerView: 1,
		spaceBetween: 8,
		speed: 1200,
		breakpoints: {
			768: {
				slidesPerView: 2.1,
				spaceBetween: 16,
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			1600: {
				slidesPerView: 4,
				spaceBetween: 16,
			}
		},
		navigation: {
			nextEl: '.similar-button-next',
			prevEl: '.similar-button-prev'
		}
	});

	const teamSlider = new Swiper('.js-team-slider', {
		slidesPerView: 1.01,
		spaceBetween: 8,
		speed: 1200,
		breakpoints: {
			768: {
				slidesPerView: 2.16,
				spaceBetween: 16,
			},
			1280: {
				slidesPerView: 2.96,
				spaceBetween: 16,
			},
			1600: {
				slidesPerView: 4,
				spaceBetween: 16,
			}
		}
	});

	const offerSlider = new Swiper('.js-offer-slider', {
		slidesPerView: 1,
		spaceBetween: 8,
		speed: 1200,
		breakpoints: {
			768: {
				slidesPerView: 2.1,
				spaceBetween: 16,
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			1600: {
				slidesPerView: 4,
				spaceBetween: 16,
			}
		},
		navigation: {
			nextEl: '.offer-button-next',
			prevEl: '.offer-button-prev'
		}
	});

	const completedProjectsSlider = new Swiper('.js-completed-projects-slider', {
		slidesPerView: 1,
		spaceBetween: 8,
		speed: 1200,
		breakpoints: {
			768: {
				slidesPerView: 1.52,
				spaceBetween: 16,
			},
			1280: {
				slidesPerView: 1.78,
				spaceBetween: 16,
			},
			1600: {
				slidesPerView: 2.27,
				spaceBetween: 16,
			}
		},
		navigation: {
			nextEl: '.completed-projects-button-next',
			prevEl: '.completed-projects-button-prev'
		}
	});

	const awardsSlider = new Swiper('.js-awards-slider', {
		slidesPerView: 1.03,
		spaceBetween: 8,
		speed: 1200,
		breakpoints: {
			768: {
				slidesPerView: 2.16,
				spaceBetween: 16,
			},
			1280: {
				slidesPerView: 3.24,
				spaceBetween: 16,
			},
			1600: {
				slidesPerView: 4,
				spaceBetween: 16,
			}
		}
	});
})